// assets/src/api/nonce.js
//
// Shared single-flight nonce refresh for a stale / statically-cached page.
//
// naluBookingVars.security is localized into the page HTML, so under full-page
// caching (WP Rocket) or a tab left open past the nonce lifetime it can be dead
// from first paint — every booking AJAX call then 403s until a reload. Any call
// that hits a 403 calls refreshNonce(): it mints a fresh nonce (admin-ajax is
// never full-page-cached) and writes it back to window.naluBookingVars.security.
// Every other call reads that value at request time, so healing the FIRST 403
// re-arms the whole flow (calendar → hold → confirm → manage → viewers).
//
// Single-flight: concurrent 403s (e.g. the modal markup fetch racing the first
// calendar load) share ONE refresh request instead of stampeding the endpoint.

let inFlight = null;

/**
 * Resolves to the fresh nonce string, or null if one couldn't be obtained.
 * Never rejects — callers treat null as "couldn't refresh, surface the original
 * failure".
 */
export function refreshNonce () {
  if (inFlight) return inFlight;

  const ajaxUrl = (window.naluBookingVars || {}).ajax_url;
  if (!ajaxUrl) return Promise.resolve(null);

  const body = new URLSearchParams();
  body.set('action', 'nalu_refresh_nonce');

  inFlight = fetch(ajaxUrl, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
    body: body.toString(),
  })
    .then((res) => (res.ok ? res.json() : null))
    .then((json) => {
      const fresh = json && json.success && json.data && json.data.security;
      if (!fresh) return null;
      window.naluBookingVars = window.naluBookingVars || {};
      window.naluBookingVars.security = fresh; // re-arm every other call in place
      return fresh;
    })
    .catch(() => null)
    .finally(() => { inFlight = null; });

  return inFlight;
}
